import { isIos_wecha, isSafari } from "@/jsUtils/mobileUtils.js";
import { useBuildInfoStore } from "@/jsUtils/dataStore";
import { Build, imgdataConvert } from "@/jsUtils/imgdataProcess";
import { ArrowLeft } from '@element-plus/icons-vue'; // 引入 ArrowLeft 图标
import { Product_Info } from "@/globalcfg";
export default {
  name: "BuildDetails",
  components: {
    // downloadpdf,
    Build,
    ArrowLeft
  },
  data() {
    return {
      loadingText: "Building...",
      isLoading: true,
      // Add loading state
      currentSelectedIndex: -1,
      detailimage: null,
      //拼装详情大图
      pixelData: null,
      //拼装详情大图像素数据
      effect_id: null,
      //拼装详情大图id

      fontSize: "16px",
      //   testimg: require("@/assets/fusebeads/imagetrans_carousel/01.png"),	//测试用图片
      buildcontrol: null,
      //拼装控制器
      builddata: null //拼装数据
    };
  },

  watch: {
    // 监听路由变化，每次路由变化时重新加载数据
    '$route'(to, from) {
      if (to.path === '/build_details') {
        this.reloadBuildInfo();
      }
    }
  },
  async mounted() {
    await this.reloadBuildInfo();
  },
  unmounted() {
    if (this.img) {
      this.img.onload = null;
      this.img.onerror = null;
      this.img = null;
    }
  },
  created() {},
  methods: {
    // 构建拼装详情页面
    async build_instance() {
      let cfg = this.getProductCfg(this.builddata.style);

      // 预加载白色和黑色颗粒图片
      await this.preloadImages(cfg.whitePart, cfg.blackPart);

      // console.log("BuildDetails build_instance cfg ", cfg);

      //初始化页面
      this.buildcontrol = new Build({
        minimapContainer: $("#minimapContainer")[0],
        partContainer: $("#part_container")[0],
        nextBut: $("#nextBut")[0],
        prevBut: $("#prevBut")[0],
        clickAlert: $("#build_alert"),
        whiteParticel: cfg.whitePart,
        blackParticel: cfg.blackPart,
        minimapParticelSize: 8,
        board_width: cfg.board_width,
        board_height: cfg.board_height,
        draw_edge_inlittleArea: cfg.draw_edge_inlittleArea
      });
    },
    getProductCfg(product_type) {
      if (Product_Info[product_type] == undefined) {
        return null;
      }
      let product_cfg = Product_Info[product_type];
      let cfg = {
        "product_type": product_type,
        "blackPart": product_cfg.blackPart_img,
        "whitePart": product_cfg.particle_img,
        "board_width": product_cfg.board_width,
        "board_height": product_cfg.board_height,
        "draw_edge_inlittleArea": false
      };

      // 由于有些产品有方向问题，所以需要从数据中读取图像的实际高和宽
      if (product_type == Product_Info.DiamondPainting.path) {
        let seqdata = this.builddata.seqdata;
        let imgdata = seqdata.data[0];
        let img_width = imgdata.width;
        let img_height = imgdata.height;
        cfg.board_width = img_width;
        cfg.board_height = img_height;
        cfg.draw_edge_inlittleArea = true;
      }

      // 有些产品的字体颜色和背景颜色不一样，这里需要重新设置一下
      if (product_type == Product_Info.FuseBeads.path) {
        let seqdata = this.builddata.seqdata;
        let imgdata = seqdata.data[0];
        let colors = imgdata.color;
        for (let i = 0; i < colors.length; ++i) {
          if (colors[i].fontRgb[0] == 0 && colors[i].fontRgb[1] == 0 && colors[i].fontRgb[2] == 0) {
            colors[i].fontRgb = [255, 255, 255];
          }
        }
      }
      return cfg;
    },
    async reloadBuildInfo() {
      const buildInfoStore = useBuildInfoStore();
      this.builddata = buildInfoStore.getBuildInfo();
      await this.initializeBuildControl();
    },
    async initializeBuildControl() {
      this.isLoading = true;
      this.$refs.build_scene_ref.style.visibility = 'hidden';
      if (!this.buildcontrol) {
        await this.build_instance();
      }

      // console.log("BuildDetails initializeBuildControl buildcontrol " , this.buildcontrol);

      // let builddata = {
      //         seqdata : this.builddata,
      //         idname : this.piexelImgInfo.id,
      //         smallimg : this.piexelImgInfo.smallimg,
      //         style : this.piexelImgInfo.product_type,
      //     }

      // 以下是拼装控制器的固定初始化流程
      // 1. 将后台生成的seqdata通过函数imgdataConvert转为像素数据，生成为rebuildimgs
      // 2. 将重建的像素数据再通过buildcontrol进行setImage，生成拼装页面的miniMap
      // 3. 开始拼装页面

      let rebuildimgs = await imgdataConvert(this.builddata.seqdata, this.buildcontrol);
      if (rebuildimgs == null || rebuildimgs.length == 0) {
        return;
      }
      let rebuildimgs_seqdata = rebuildimgs[0].seqdata;
      this.buildcontrol.effectImg = this.builddata.smallimg;
      this.buildcontrol.pixelData = rebuildimgs_seqdata;
      this.buildcontrol.effect_id = this.builddata.idname;
      await this.buildcontrol.setImage(this.builddata.smallimg, this.builddata.smallimg, rebuildimgs_seqdata);
      this.buildcontrol.startBuild();
      this.$refs.build_scene_ref.style.visibility = 'visible';
      this.isLoading = false;
    },
    // 返回图标的处理方法
    goBack() {
      const buildInfoStore = useBuildInfoStore();
      buildInfoStore.clearBuildInfo(); // 清除 buildInfo 数据

      // buildcontrol也需要清空
      if (this.buildcontrol) {
        this.buildcontrol.clear();
        this.buildcontrol = null;
      }
      this.$router.back(); // 返回上一页
    },

    /**
     * 预加载单个图片
     * @param {String} src - 图片的路径
     * @returns {Promise} - 图片加载完成的 Promise
     */
    preloadImage(src) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error(`Failed to load image: ${src}`));
        img.src = src;
      });
    },
    /**
     * 预加载白色和黑色颗粒图片
     * @param {String} whiteSrc - 白色颗粒的图片源
     * @param {String} blackSrc - 黑色颗粒的图片源
     * @returns {Promise} - 两张图片都加载完成的 Promise
     */
    preloadImages(whiteSrc, blackSrc) {
      return Promise.all([this.preloadImage(whiteSrc), this.preloadImage(blackSrc)]);
    }
  }
};